import { amplitudeEvent } from 'lib/amplitude'
import { gtmEvent } from 'lib/gtm'

export const VIRTUAL_COACHING_EVENTS = {
  OFFERING_CREATED: 'virtual-coaching-offering-created',
  REQUEST_VIEWED: 'virtual-coaching-request-viewed',
  ONFORM_CLICKED: 'virtual-coaching-onform-clicked',
  DOWNLOAD_CLICKED: 'virtual-coaching-download-clicked',
  REPLY_SHARED: 'virtual-coaching-reply-shared',
  DASHBOARD_TASK_CLICKED: 'virtual-coaching-dashboard-task-clicked',
  DASHBOARD_ROW_CLICKED: 'virtual-coaching-dashboard-row-clicked',
}

export const trackVirtualCoachingEvent = (event, attributes = {}) => {
  amplitudeEvent(event, {
    path: window.location.pathname,
    ...attributes,
  })
}

export const trackVirtualCoachingFormSubmit = formAction => {
  gtmEvent({
    event: 'formSubmit',
    formCategory: 'virtual-coaching',
    formAction,
    formStatus: 'success',
  })
}
